import React from 'react';
import ExportLink from '@components/export/Link';
import { trendsExportConfig, appEventsExportConfig } from '@components/export/utils';
import { CLICK_EXPORT_TRENDS } from '@src/utils/sensor/track';
import { isAppModule } from '@utils/constants';

function ExportOption() {
  const config = isAppModule ? appEventsExportConfig : trendsExportConfig;
  return <ExportLink config={config} trackEvent={CLICK_EXPORT_TRENDS} />;
}

export default ExportOption;
